import axios, { AxiosInstance, AxiosResponse } from "axios";

import { Config } from "./interfaces";
import { BASE_API_URL } from "./constants";

export class Client {
  private request: AxiosInstance;

  constructor(options: Config) {
    this.request = axios.create({
      baseURL: BASE_API_URL,
      headers: {
        Authorization: `Bearer ${options.api_key}`,
      },
    });
  }

  public async get(
    path: string,
    query: URLSearchParams
  ): Promise<AxiosResponse<any, any>> {
    const parameters = `?` + new URLSearchParams(query).toString();
    return this.request.get(`${path}?${parameters}`);
  }

  public async post(
    path: string,
    data: object
  ): Promise<AxiosResponse<any, any>> {
    return this.request.post(`${path}`, data);
  }
}
